import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StateAndProvision } from '@core/domain-classes/state-and-provision';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StateAndProvisionService {

  constructor(private httpClient: HttpClient) { }

  getAllStatesProvince(): Observable<StateAndProvision[]>{
    const url = `GetAllStates`;
    return this.httpClient.get<StateAndProvision[]>(url);
  }

  getStatesProvinceById(id): Observable<StateAndProvision>{
    const url = `GetStatesProvinces/${id}`;
    return this.httpClient.get<StateAndProvision>(url);
  }

  addStatesProvince(body): Observable<HttpResponse<any>>{
    const url = `AddStatesProvince`;
    return this.httpClient.post<any>(url, body);
  }

  updateStatesProvince(id, body): Observable<HttpResponse<any>>{
    const url = `UpdateStatesProvince/${id}`;
    return this.httpClient.put<any>(url, body);
  }

  deleteStateProvince(id): Observable<HttpResponse<any>>{
    const url = `DeleteStateProvince/${id}`;
    return this.httpClient.delete<any>(url);
  }
}
